<template>
  <div style="height:100%;overflow: auto;overflow-x: hidden;">
    <div class="logo-con" :style="{background: menuTheme !== 'dark'?'#497ff7':''}" style="margin-top: 10px;margin-bottom: 20px;">
      <!--展开时左侧上面的图片-->
      <a @click="herfchange" v-show="!sidebar"><img src="../../assets/logo.png" class="maxlogo"/></a>
      <!--菜单收起时左侧显示的图片-->
      <a @click="herfchange" v-show="sidebar"><img src="../../assets/logo-mini.png"/></a>
    </div>
    <Menu v-if="!sidebar" ref="sideMenu" :active-name="$route.path" :theme="menuTheme" :open-names="openedSubmenuArr"
          width="auto" @on-select="changeMenu" style="background:#497ff7 ">
      <template v-for="item in permission_routers"
                v-if="!item.hidden && item.children.length>0 && item.path.split('/')[1] === menu" style="color:#FFF">
        <!--有二级菜单的设置路由-->
        <template v-for="child in item.children">
          <!--设置下面的二级菜单显示-->
          <MenuItem :name="item.path+'/'+child.path" :key="child.name" style="color:#ffffff;position: relative;overflow: hidden;padding: 26px 0;">
            <!-- <Icon :type="child.icon" :size="iconSize"></Icon> -->
            <svg-icon :icon-class="child.icon" style="margin-right: 6px;font-size: 30px;position: absolute;left: 16px;top:50%;transform: translate(0,-50%);" />
            <span class="layout-text" style="font-size: 16px;position: absolute;left: 48px;top: 54%;transform: translate(0,-50%);"  >{{ child.title }}</span>
          </MenuItem>
        </template>
      </template>
    </Menu>
    <div v-else-if="sidebar" class="shrink">
      <template v-for="(item,index) in permission_routers"
                v-if="!item.hidden && item.children.length>0 && item.path.split('/')[1] === menu">
        <!--只展示选择的那个一级菜单的二级菜单-->
        <!--有二级菜单的展示-->
        <Dropdown transfer v-if="item.children.length !== 0" placement="right-start" :key="index"
                  @on-click="changeMenu">
        </Dropdown>
        <template v-for="(child, i) in item.children">
          <Dropdown transfer v-if="item.children.length !== 0" placement="right-start" :key="index"
                    @on-click="changeMenu">
            <router-link tag='span' :to="item.path+'/'+child.path"
                         style="display: inline-block;height:100%;width:100%">
              <Button class="shrinkbutton" type="text">
                <svg-icon :icon-class="child.icon" style="font-size: 34px;color: #FFFFFF;" />
                <!-- <Icon :size="20" :color="iconColor" :type="child.icon"/> -->
              </Button>
            </router-link>
            <DropdownMenu class="shrinkdropdownMenu" slot="list">
              <DropdownItem :name="item.path+'/'+child.path" :key="i">
                <!-- <Icon :type="child.icon"/> -->
                <svg-icon :icon-class="child.icon" style="color: #495060;font-size: 16px;" />
                <span class="dropdownItemIcon" style="color: #495060;font-size: 14px;">{{ child.title }}</span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </template>
    </div>
  </div>
</template>
<script>

  import {mapGetters} from 'vuex';

  export default {
    data() {
      return {
        iconSize: 14,
        //当前选中导航的name
        menu: ""
      }
    },
    mounted() {
      console.log(localStorage.getItem("routerPath"))
      console.log(this.routerPath)
    },
    computed: {
      ...mapGetters([
        'permission_routers',
        'sidebar',
        'routerPath'
      ]),
      menuTheme() {
        return this.$store.state.app.menuTheme;
      },
      openedSubmenuArr() {
        let n = this.$route.path.split("/")[1];
        console.log(n);
        return [n];
      },
      iconColor() {
        return this.$store.state.app.menuTheme === 'dark' ? 'white' : '#497ff7';
      },
    },
    methods: {
      changeMenu(active) {
        this.$router.push(active);
        this.$store.commit('setRouterPath',this.$route.path);
        localStorage.setItem("routerPath", this.$route.path);
      },
      changeNavMenu(url) {
        this.menu = url;
      },
      herfchange() {
        let path = "/";
        this.$router.push(path);
        this.menu = 'home';
      },
    },
  }
</script>

<style scoped lang="less">

  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):hover, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu):hover {
    background: #1f57ce;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #fff;
    background: #235ad6;
  }
  .shrink {
    text-align: center;
    .shrinkbutton {
      width: 65px;
      padding: 10px 0;
    }
    .shrinkdropdownMenu {
      width: 200px;
    }
    .dropdownItemIcon {
      padding-left: 10px;
    }


  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue?7f1fd200